module.exports = __webpack_public_path__ + "static/new-features-06049ec490750977f59ff349f60f5aca.png";